import Vue from 'vue'
import Vuex from 'vuex'
import { CategoriesService } from "../common/api.service"
import ClientHelper from '../common/client.helper'
import languages from './modules/languages'
import articles from './modules/articles'
import messages from './modules/messages'
import createplusTemplates from './modules/createplus/templates'
import createplusMessages from './modules/createplus/messages'

Vue.use(Vuex)

export default new Vuex.Store({
 state: {
  pinf: "",
  setupnavi: {},
  os: "",
  locale: '',
  languageChangeCount: 0,
  lg2:'',
  shouldDisplayAllArticles: false,
  shouldDisplayAllDesignpaper: false,
  showLangModal: false,
  showHumbugerMenu: false,
  categories: [],
  categoryItems: [],
  designPaperParameters: {
    articleIdToSamplePage: null,
    mediaSize: null,
    mediaType: []
  }
 },
 mutations: {
   setUrlParm(state, payload) {
    state.locale = payload.locale || ''
    state.pinf = payload.PINF ||"fun"
    state.lg2 = payload.LG2 || ClientHelper.getLanguage()
    state.exe = payload.EXE || ""
    state.setupnavi.mkn = payload.MKN || ""
    state.setupnavi.osc = payload.OSC || ""
    state.os = ClientHelper.getOs()
   },
   setLangPath(state, payload) {
     let urlPath = payload.split('/')[1]
     if (urlPath === 'createplus') {
       urlPath = payload.split('/')[2]
     }
     if(!urlPath == '') {
       state.lg2 = ClientHelper.checkLanguageCode(urlPath)
     }
   },
   changeLanguage(state, payload) {
     state.lg2 = payload
     state.languageChangeCount += 1
   },
   setShouldDisplayAllArticles(state, payload) {
     state.shouldDisplayAllArticles = payload
   },
   setShouldDisplayAllDesignpaper(state, payload) {
     state.shouldDisplayAllDesignpaper = payload
   },
   setShowLangModal(state, payload) {
    state.showLangModal = payload
   },
   setShowHumbugerMenu(state, payload) {
    state.showHumbugerMenu = payload
   },
   setCategories(state, payload) {
     state.categories = payload.categories
     state.categoryItems = payload.categoryItems
   },
   setLocale(state, payload) {
     state.locale = payload
   },
   setLg2(state, payload) {
     state.lg2 = payload
   },
   setDesignPaperParameters(state, payload) {
     state.designPaperParameters = payload
   }
 },
 actions: {
    async fetchCategories({ commit }) {
      return await CategoriesService.get()
      .then(({ data }) => {
        commit('setCategories', data)
        return data
      })
      .catch((reason) => {
        console.log(reason.message)
      })
    },
    passSamplePage(context, payload) {
      context.commit('setDesignPaperParameters', payload)
    }
  },
  getters: {
    getStateDataSet: state => {
      return state.dataSet
    },
    isJpTemplate: state => {
      return state.locale == 'jp'
    },
    isWwTemplate: state => {
      return state.locale == 'ww'
    },
    isBuiltInApp: state => {
      return state.exe.startsWith("BUILTIN_")
    },
    getCategories: state => {
      return state.categories
    },
    getCategoryItems: state => {
      return state.categoryItems
    },
    /**
     * Muuriでフィルタ表示するためのカテゴリ情報を付与した記事一覧の取得
     */
    getArticlesForMuuri: state => {
      let seasonPriority = getSeasonPriority()
      return state.articles.articles.map(article => {
        let categories = state.categoryItems.filter(item => item.articleId === article.id).map(item => {
          let priority
          switch(item.categoryId){
            // special-editions
            case 1:
              priority = new Date(article.releaseDate).getTime()
              break
            // seasonal-events
            case 7:
              priority = `${seasonPriority[item.section]}${item.priority}`
              break
            default:
              priority = item.priority
              break
          }
          return {
            categoryId: item.categoryId,
            priority: priority
          }
        })
        return {
          id: article.id,
          releaseDate: article.releaseDate,
          categories: categories
        }
      })
    },
    getDesignPaperParameters: state => {
      return state.designPaperParameters
    }
  },
  modules: {
    languages: languages,
    articles: articles,
    messages: messages,
    createplusTemplates: createplusTemplates,
    createplusMessages: createplusMessages
  }
})

/**
 * 現在の月に合わせた季節の並び順を取得する
 * @return {array} - {春, 夏, 秋, 冬} の並び順リスト
 */
function getSeasonPriority(){
    let thisMonth = new Date().getMonth()+1
    switch (thisMonth){
      // 春
      case 3:
      case 4:
      case 5:
        return {1: 4, 2: 3, 3: 2, 4: 1}
      // 夏
      case 6:
      case 7:
      case 8:
        return {1: 1, 2: 4, 3: 3, 4: 2}
      // 秋
      case 9:
      case 10:
      case 11:
        return {1: 2, 2: 1, 3: 4, 4: 3}
      // 冬
      default:
        return {1: 3, 2: 2, 3: 1, 4: 4}
    }
}